import { useMemo, useState, useEffect } from 'react';
import { DataGrid } from '../Common';
import { select_commonCellProps } from '../Common/DataGrid/utils';
import { trakrefBlue } from '../../color_utils';
import Routes from '../../routes';

const LeakInspectionLocationTable = ({ year, frequency, regulations, onLocationClick }) => {
    const [filterOptions, setFilterOptions] = useState([]);

    useEffect(() => {
        const load = async () => {
            const res = await fetch(Routes.Dashboard.LeakInspectionFilters());
            const data = await res.json();
            setFilterOptions(data.tableFilters ?? []);
        };
        load();
    }, []);

    const staticFilters = [
        { property: 'year', value: String(year) },
        { property: 'frequency', value: frequency },
        ...(regulations || []).map(r => ({ property: 'regulations', value: r }))
    ];

    const columns = useMemo(() => [
        {
            field: 'locationName',
            headerName: 'Location',
            ...select_commonCellProps,
            renderCell: ({ row }) => (
                <span
                    style={{ color: trakrefBlue, cursor: 'pointer', fontWeight: 600 }}
                    onClick={() => onLocationClick(row.locationName)}
                >
                    {row.locationName}
                </span>
            )
        },
        {
            field: 'regionName',
            headerName: 'Region/Division',
            ...select_commonCellProps
        },
        {
            field: 'serviceCompanyName',
            headerName: 'Service Company',
            ...select_commonCellProps
        },
        {
            field: 'frequency',
            headerName: 'Frequency',
            ...select_commonCellProps
        },
        {
            field: 'required',
            headerName: 'Required',
            type: 'number'
        },
        {
            field: 'completed',
            headerName: 'Completed',
            type: 'number'
        },
        {
            field: 'missed',
            headerName: 'Missed',
            type: 'number'
        },
        {
            field: 'complianceRate',
            headerName: '% Compliance',
            type: 'number',
            renderCell: ({ row }) => row.complianceRate != null ? `${row.complianceRate}%` : '-'
        },
    ], [onLocationClick]);

    return (
        <DataGrid
            url={Routes.Dashboard.LeakInspectionLocations(false)}
            exportButtonURL={Routes.Dashboard.LeakInspectionLocations(true)}
            exportButtonAlt="Export Locations (.csv)"
            columns={columns}
            filterOptions={filterOptions}
            staticFilters={staticFilters}
            noResultText="No locations found."
            noResultText2="Change your filters or check back later."
        />
    );
};

export default LeakInspectionLocationTable;
